import React, { useCallback, useMemo } from 'react';
import { createFormField } from 'Shared/utils/createFormField';

import VideoRecorderUi from 'Shared/components/VideoRecorder/VideoRecorder';
import WpButton from 'Wpds/components/button/WpButton';
import WpIcon from 'Wpds/components/icon/WpIcon';
import { useToggle } from 'Shared/utils/hooks';

import './FormVideoRecorder.scss';

type Props = {
  className?: string;
  previewClassName?: string;
  showRecordButton?: boolean;
  showRecorder?: boolean;
  value?: {
    file: Blob;
    preview: string;
    audioOnly: boolean;
    url: string;
  };
  toggleRecorder?: Function;
  onChange: Function;
  onFocus?: Function;
  onBlur?: Function;
};

function VideoRecorder({
  onChange,
  onFocus,
  onBlur,
  value,
  showRecordButton = true,
  showRecorder = false,
  toggleRecorder,
  className = '',
  previewClassName = '',
}: Props) {
  const [hide, toggleHide] = useToggle(true);

  const handleVideoRecorderHideToggle = useCallback(() => {
    if (toggleRecorder) return toggleRecorder();
    return toggleHide();
  }, [toggleRecorder]);

  const handleRemoveVideo = useCallback(() => {
    onChange(null);
    if (onFocus) setTimeout(onFocus);
    if (onBlur) setTimeout(onBlur);
  }, [onBlur, onChange, onFocus]);

  const videoSrc = useMemo(() => (value ? value.url || window.URL.createObjectURL(value.file) : null), [value]);

  return (
    <div className={`FormVideoRecorder ${className}`}>
      {value && (
        <div className={`FormVideoRecorder__video-preview position-relative ${previewClassName}`}>
          <div className="FormVideoRecorder__video-preview__btn-close position-absolute">
            <WpButton variant="tertiary" color="danger" onClick={handleRemoveVideo}>
              <WpIcon name="trash" />
            </WpButton>
          </div>
          <video controls src={videoSrc} width="100%" height="100%" />
        </div>
      )}
      {showRecordButton && !value && (
        <WpButton size="lg" variant="secondary" onClick={handleVideoRecorderHideToggle}>
          <WpIcon size="lg" name="video-plus" />
          Record a Video
        </WpButton>
      )}
      {(!hide || showRecorder) && <VideoRecorderUi onSave={onChange} onHide={handleVideoRecorderHideToggle} />}
    </div>
  );
}

export default createFormField(VideoRecorder);
